(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  class JournalReadingToolbar extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.articleBody = document.getElementById(this.dataset.articleContentId);
      this.articleRoot = document.getElementById(this.dataset.articleRootId);
      if (!this.articleBody || !this.articleRoot) return;

      this.sizes = [16, 18, 20];
      this.sizeIndex = 0;
      this.decreaseButton = this.querySelector('[data-decrease]');
      this.increaseButton = this.querySelector('[data-increase]');
      this.progress = this.querySelector('[data-progress]');
      this.topButton = this.querySelector('[data-top]');
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };

      this.decreaseButton?.addEventListener('click', () => this.changeSize(-1), options);
      this.increaseButton?.addEventListener('click', () => this.changeSize(1), options);
      this.topButton?.addEventListener('click', () => this.scrollToTop(), options);
      window.addEventListener('scroll', () => this.requestProgressUpdate(), { ...options, passive: true });
      window.addEventListener('resize', () => this.requestProgressUpdate(), options);

      this.updateSize();
      this.updateProgress();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.initialized = false;
    }

    changeSize(direction) {
      this.sizeIndex = Math.max(0, Math.min(this.sizes.length - 1, this.sizeIndex + direction));
      this.updateSize();
      this.requestProgressUpdate();
    }

    updateSize() {
      this.articleBody.style.setProperty('--journal-article-body-size', `${this.sizes[this.sizeIndex]}px`);
      if (this.decreaseButton) this.decreaseButton.disabled = this.sizeIndex === 0;
      if (this.increaseButton) this.increaseButton.disabled = this.sizeIndex === this.sizes.length - 1;
    }

    requestProgressUpdate() {
      if (this.progressFrame) return;
      this.progressFrame = window.requestAnimationFrame(() => {
        this.progressFrame = null;
        this.updateProgress();
      });
    }

    updateProgress() {
      if (!this.progress || !this.articleBody) return;
      const rect = this.articleBody.getBoundingClientRect();
      const readAmount = window.innerHeight - rect.top;
      const percentage = Math.round(Math.max(0, Math.min(1, readAmount / Math.max(rect.height, 1))) * 100);
      this.progress.textContent = `${percentage}%`;
    }

    scrollToTop() {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.articleRoot.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }
  }

  if (!customElements.get('journal-reading-toolbar')) {
    customElements.define('journal-reading-toolbar', JournalReadingToolbar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('cart-drawer')) {
    class CartDrawer extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.options = { signal: this.controller.signal };
        this.dialog = this.querySelector('[data-cart-drawer-dialog]');
        this.content = this.querySelector('[data-cart-drawer-content]');
        this.liveRegion = this.querySelector('[data-cart-live]');
        this.busy = false;

        document.addEventListener('click', (event) => this.handleClick(event), this.options);
        document.addEventListener('submit', (event) => this.handleSubmit(event), this.options);
        document.addEventListener('change', (event) => this.handleChange(event), this.options);
        document.addEventListener('keydown', (event) => this.handleKeydown(event), this.options);
      }

      disconnectedCallback() {
        this.controller?.abort();
        document.documentElement.classList.remove('cart-drawer-open');
      }

      handleClick(event) {
        const opener = event.target.closest('[data-cart-drawer-open]');
        if (opener) {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.open(opener);
          return;
        }

        if (event.target.closest('[data-cart-drawer-close]')) {
          event.preventDefault();
          this.close();
          return;
        }

        const removeControl = event.target.closest('[data-cart-remove]');
        if (removeControl) {
          event.preventDefault();
          this.changeLine(removeControl.dataset.lineKey, 0);
          return;
        }

        const quantityControl = event.target.closest('[data-cart-quantity-change]');
        if (quantityControl) {
          event.preventDefault();
          this.changeLine(quantityControl.dataset.lineKey, Number(quantityControl.dataset.quantity));
        }
      }

      handleChange(event) {
        const input = event.target.closest('[data-cart-quantity-input]');
        if (!input) return;
        const quantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
        this.changeLine(input.dataset.lineKey, quantity);
      }

      handleSubmit(event) {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (!/\/cart\/add(?:\.js)?$/.test(new URL(form.action, window.location.origin).pathname)) return;

        const submitter = event.submitter;
        if (submitter?.closest('.shopify-payment-button')) return;
        if (submitter?.name === 'checkout') return;

        event.preventDefault();
        this.addProduct(form, submitter);
      }

      handleKeydown(event) {
        if (!this.classList.contains('is-open')) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          return;
        }

        if (event.key !== 'Tab') return;
        const focusable = [...this.dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])')]
          .filter((element) => element.getClientRects().length > 0);
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      open(opener) {
        this.previouslyFocused = opener || document.activeElement;
        this.dialog.removeAttribute('inert');
        this.dialog.setAttribute('aria-hidden', 'false');
        this.classList.add('is-open');
        document.documentElement.classList.add('cart-drawer-open');
        document.querySelectorAll('[data-cart-drawer-open]').forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'true');
        });
        requestAnimationFrame(() => this.querySelector('[data-cart-drawer-close]:not([data-cart-drawer-backdrop])')?.focus());
      }

      close() {
        this.classList.remove('is-open');
        this.dialog.setAttribute('aria-hidden', 'true');
        this.dialog.setAttribute('inert', '');
        document.documentElement.classList.remove('cart-drawer-open');
        document.querySelectorAll('[data-cart-drawer-open]').forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
        });
        this.previouslyFocused?.focus();
      }

      async addProduct(form, submitter) {
        if (this.busy) return;
        this.setBusy(true);
        this.setError('');
        if (submitter) submitter.disabled = true;

        try {
          const variantInput = form.elements.namedItem('id');
          const quantityInput = form.elements.namedItem('quantity');
          const variantId = Number.parseInt(variantInput?.value, 10);
          const quantity = Math.max(1, Number.parseInt(quantityInput?.value, 10) || 1);

          if (!variantId) throw new Error(this.dataset.cartErrorMessage);

          const sectionIds = this.sectionIds();
          const payload = {
            items: [{ id: variantId, quantity }],
          };
          if (sectionIds.length) {
            payload.sections = sectionIds;
            payload.sections_url = this.sectionsUrl();
          }

          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
          });
          const data = await this.parseJsonResponse(response, 'Cart add');
          const [sections, cartState] = await Promise.all([
            this.resolveSections(data.sections, sectionIds),
            this.fetchCart(),
          ]);

          this.renderSections(sections, sectionIds);
          this.updateCartCount(cartState.item_count);
          this.announce(this.dataset.cartUpdateMessage);
          this.open(document.querySelector('[data-cart-drawer-open]') || submitter || form);
        } catch (error) {
          console.error('[Lampeek cart] Add to cart failed.', error);
          this.setError(this.dataset.cartErrorMessage);
        } finally {
          this.setBusy(false);
          if (submitter) submitter.disabled = false;
        }
      }

      async changeLine(lineKey, quantity) {
        if (this.busy) return;

        const normalizedLineKey = this.normalizeIdentifier(lineKey);
        const normalizedQuantity = Number(quantity);
        if (!normalizedLineKey || !Number.isInteger(normalizedQuantity) || normalizedQuantity < 0) {
          console.warn('[Lampeek cart] Ignored an invalid cart change request.');
          return;
        }
        this.setBusy(true);
        this.setError('');

        try {
          const sectionIds = this.sectionIds();
          const currentCart = await this.fetchCart();
          if (!this.cartContainsLineKey(currentCart, normalizedLineKey)) {
            console.warn('[Lampeek cart] Ignored a stale cart line key after a cart re-render.');
            const currentSections = await this.fetchSections(sectionIds);
            this.renderSections(currentSections, sectionIds);
            this.updateCartCount(currentCart.item_count);
            return;
          }

          const payload = {
            id: normalizedLineKey,
            quantity: normalizedQuantity,
          };
          if (sectionIds.length) {
            payload.sections = sectionIds;
            payload.sections_url = this.sectionsUrl();
          }

          const response = await fetch(this.dataset.cartChangeUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
          });
          const data = await this.parseJsonResponse(response, 'Cart change');
          const sections = await this.resolveSections(data.sections, sectionIds);
          const cartState = Array.isArray(data.items) ? data : await this.fetchCart();

          this.renderSections(sections, sectionIds);
          this.updateCartCount(cartState.item_count);
          this.announce(this.dataset.cartUpdateMessage);
        } catch (error) {
          console.error('[Lampeek cart] Cart quantity change failed.', error);
          this.setError(this.dataset.cartErrorMessage);
        } finally {
          this.setBusy(false);
        }
      }

      normalizeIdentifier(value) {
        if (typeof value !== 'string' && typeof value !== 'number') return '';
        const identifier = String(value).trim();
        if (!identifier || identifier === 'null' || identifier === 'undefined') return '';
        return identifier;
      }

      drawerSectionId() {
        const wrapperId = this.closest('[id^="shopify-section-"]')?.id;
        const wrapperSectionId = wrapperId?.replace(/^shopify-section-/, '');
        return this.normalizeIdentifier(wrapperSectionId);
      }

      cartPageSectionId() {
        const cartPage = document.querySelector('[data-cart-page]');
        const wrapperId = cartPage?.closest('[id^="shopify-section-"]')?.id;
        const wrapperSectionId = wrapperId?.replace(/^shopify-section-/, '');
        return this.normalizeIdentifier(wrapperSectionId);
      }

      sectionIds() {
        return [...new Set([this.drawerSectionId(), this.cartPageSectionId()].filter(Boolean))];
      }

      sectionsUrl() {
        const url = new URL(window.location.href);
        url.searchParams.delete('section_id');
        url.searchParams.delete('sections');
        return `${url.pathname}${url.search}`;
      }

      sectionRequestUrl(sectionIds) {
        const url = new URL(window.location.href);
        url.searchParams.delete('section_id');
        url.searchParams.set('sections', sectionIds.join(','));
        return `${url.pathname}${url.search}`;
      }

      async parseJsonResponse(response, requestName) {
        let data = null;
        try {
          data = await response.json();
        } catch (error) {
          console.error(`[Lampeek cart] ${requestName} JSON parsing failed.`, error);
          throw new Error(`${requestName} returned invalid JSON.`);
        }

        if (!response.ok) {
          const serverMessage = data?.description || data?.message || `${requestName} failed with status ${response.status}.`;
          throw new Error(serverMessage);
        }
        if (!data || typeof data !== 'object' || Array.isArray(data)) {
          throw new Error(`${requestName} returned an invalid response.`);
        }
        return data;
      }

      async fetchCart() {
        const response = await fetch(this.dataset.cartUrl, {
          headers: { Accept: 'application/json' },
        });
        return this.parseJsonResponse(response, 'Cart refresh');
      }

      async fetchSections(sectionIds) {
        if (!sectionIds.length) return {};
        const response = await fetch(this.sectionRequestUrl(sectionIds), {
          headers: { Accept: 'application/json' },
        });
        return this.parseJsonResponse(response, 'Cart section refresh');
      }

      hasUsableSectionHtml(sectionId, html) {
        if (typeof html !== 'string' || !html.trim()) return false;
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        if (sectionId === this.drawerSectionId()) {
          return Boolean(documentFragment.querySelector('[data-cart-drawer-content]'));
        }
        if (sectionId === this.cartPageSectionId()) {
          return Boolean(documentFragment.getElementById(`shopify-section-${sectionId}`));
        }
        return false;
      }

      async resolveSections(bundledSections, sectionIds) {
        const resolvedSections = {};
        const responseSections = bundledSections && typeof bundledSections === 'object' && !Array.isArray(bundledSections)
          ? bundledSections
          : {};

        sectionIds.forEach((sectionId) => {
          if (this.hasUsableSectionHtml(sectionId, responseSections[sectionId])) {
            resolvedSections[sectionId] = responseSections[sectionId];
          }
        });

        const missingSectionIds = sectionIds.filter((sectionId) => !resolvedSections[sectionId]);
        if (missingSectionIds.length) {
          const fallbackSections = await this.fetchSections(missingSectionIds);
          missingSectionIds.forEach((sectionId) => {
            if (this.hasUsableSectionHtml(sectionId, fallbackSections[sectionId])) {
              resolvedSections[sectionId] = fallbackSections[sectionId];
            }
          });
        }

        const drawerSectionId = this.drawerSectionId();
        if (drawerSectionId && !resolvedSections[drawerSectionId]) {
          throw new Error('The cart drawer section could not be refreshed.');
        }
        return resolvedSections;
      }

      cartContainsLineKey(cartState, lineKey) {
        if (!Array.isArray(cartState?.items)) return false;
        return cartState.items.some((item) => this.normalizeIdentifier(item.key) === lineKey);
      }

      renderSections(sections, sectionIds) {
        if (!sections || typeof sections !== 'object' || Array.isArray(sections)) return;
        const parser = new DOMParser();
        const drawerSectionId = this.drawerSectionId();
        const drawerHtml = drawerSectionId ? sections[drawerSectionId] : null;
        if (this.hasUsableSectionHtml(drawerSectionId, drawerHtml)) {
          const drawerDocument = parser.parseFromString(drawerHtml, 'text/html');
          const incomingContent = drawerDocument.querySelector('[data-cart-drawer-content]');
          if (incomingContent && this.content?.isConnected) {
            this.content.className = incomingContent.className;
            this.content.dataset.cartItemCount = incomingContent.dataset.cartItemCount;
            this.content.innerHTML = incomingContent.innerHTML;
          }
        }

        const pageSectionId = sectionIds.find((sectionId) => sectionId !== drawerSectionId && sectionId === this.cartPageSectionId());
        const pageHtml = pageSectionId ? sections[pageSectionId] : null;
        if (this.hasUsableSectionHtml(pageSectionId, pageHtml)) {
          const pageDocument = parser.parseFromString(pageHtml, 'text/html');
          const incomingSection = pageDocument.getElementById(`shopify-section-${pageSectionId}`);
          const currentSection = document.getElementById(`shopify-section-${pageSectionId}`);
          if (incomingSection && currentSection) currentSection.replaceWith(incomingSection);
        }

        window.Shopify?.PaymentButton?.init?.();
      }

      updateCartCount(count) {
        document.querySelectorAll('[data-cart-drawer-open]').forEach((trigger) => {
          let bubble = trigger.querySelector('[data-cart-count]');
          if (!bubble) {
            bubble = document.createElement('span');
            bubble.className = 'site-header__cart-count';
            bubble.dataset.cartCount = '';
            bubble.setAttribute('aria-hidden', 'true');
            trigger.append(bubble);
          }
          bubble.textContent = count;
          bubble.hidden = count === 0;
        });
      }

      setBusy(isBusy) {
        this.busy = isBusy;
        document.querySelectorAll('[data-cart-control]').forEach((control) => {
          if ('disabled' in control) control.disabled = isBusy;
          control.setAttribute('aria-disabled', String(isBusy));
        });
      }

      setError(message) {
        document.querySelectorAll('[data-cart-error]').forEach((element) => {
          element.textContent = message;
        });
        if (message) this.announce(message);
      }

      announce(message) {
        this.liveRegion.textContent = '';
        requestAnimationFrame(() => {
          this.liveRegion.textContent = message;
        });
      }
    }

    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  if (!customElements.get('collection-infinite-scroll')) {
    class CollectionInfiniteScroll extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.grid = this.querySelector('[data-collection-grid]');
        this.sentinel = this.querySelector('[data-collection-sentinel]');
        this.status = this.querySelector('[data-collection-load-status]');
        this.pagination = this.querySelector('[data-collection-pagination]');
        this.nextPageUrl = this.normalizePageUrl(this.dataset.nextPageUrl);
        this.hasMore = Boolean(this.nextPageUrl);
        this.isLoading = false;
        this.retryAttempts = 0;
        this.loadedPageUrls = new Set();
        this.cardIdentities = new Set(
          [...this.querySelectorAll('[data-card-identity]')]
            .map((card) => card.dataset.cardIdentity)
            .filter(Boolean),
        );

        if (!('IntersectionObserver' in window) || !this.grid) return;
        this.classList.add('is-enhanced');
        if (!this.hasMore || !this.sentinel) {
          this.finish();
          return;
        }

        this.observer = new IntersectionObserver((entries) => this.handleIntersection(entries), {
          rootMargin: '800px 0px',
          threshold: 0,
        });
        this.observer.observe(this.sentinel);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        window.clearTimeout(this.retryTimer);
      }

      handleIntersection(entries) {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.loadNextPage();
      }

      async loadNextPage() {
        if (this.isLoading || !this.hasMore || !this.nextPageUrl) return;
        if (this.loadedPageUrls.has(this.nextPageUrl)) {
          this.finish();
          return;
        }

        const requestedPageUrl = this.nextPageUrl;
        this.isLoading = true;
        this.classList.add('is-loading');
        this.setAttribute('aria-busy', 'true');
        this.observer?.unobserve(this.sentinel);
        this.announce(this.dataset.loadingMessage);

        try {
          const requestUrl = new URL(requestedPageUrl, window.location.origin);
          if (this.dataset.sectionId) requestUrl.searchParams.set('section_id', this.dataset.sectionId);

          const response = await fetch(requestUrl, {
            headers: { Accept: 'text/html' },
            credentials: 'same-origin',
          });
          if (!response.ok) throw new Error(`Collection request failed with ${response.status}`);

          const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = responseDocument.querySelector('[data-collection-infinite-scroll]');
          const incomingGrid = incoming?.querySelector('[data-collection-grid]');
          if (!incoming || !incomingGrid) throw new Error('Collection response did not contain a product grid');

          const incomingCardIdentities = new Set();
          const incomingCards = [...incomingGrid.children].filter((card) => {
            const identity = card.dataset.cardIdentity;
            if (!identity || this.cardIdentities.has(identity) || incomingCardIdentities.has(identity)) return false;
            incomingCardIdentities.add(identity);
            return true;
          });
          const orderedCards = this.avoidBoundarySiblings(incomingCards);
          const fragment = document.createDocumentFragment();
          orderedCards.forEach((card) => {
            this.cardIdentities.add(card.dataset.cardIdentity);
            fragment.append(card);
          });
          this.grid.append(fragment);

          this.loadedPageUrls.add(requestedPageUrl);
          this.retryAttempts = 0;
          this.updatePagination(incoming);

          const incomingNextPageUrl = this.normalizePageUrl(incoming.dataset.nextPageUrl);
          this.nextPageUrl = incomingNextPageUrl === requestedPageUrl ? '' : incomingNextPageUrl;
          this.dataset.nextPageUrl = this.nextPageUrl;
          this.hasMore = Boolean(this.nextPageUrl);
          this.announce((this.dataset.loadedMessage || '[count] more products loaded').replace('[count]', orderedCards.length));

          if (!this.hasMore) this.finish();
        } catch (error) {
          this.handleLoadError();
        } finally {
          this.isLoading = false;
          this.classList.remove('is-loading');
          this.removeAttribute('aria-busy');

          if (this.hasMore && this.sentinel && this.retryAttempts === 0) {
            this.observer?.observe(this.sentinel);
          }
        }
      }

      avoidBoundarySiblings(cards) {
        const lastParentId = this.grid.lastElementChild?.dataset.parentProductId;
        if (!lastParentId || cards.length < 2 || cards[0].dataset.parentProductId !== lastParentId) return cards;

        const firstDifferentParent = cards.findIndex((card) => card.dataset.parentProductId !== lastParentId);
        if (firstDifferentParent < 1) return cards;
        return [...cards.slice(firstDifferentParent), ...cards.slice(0, firstDifferentParent)];
      }

      normalizePageUrl(url) {
        if (!url) return '';
        const normalizedUrl = new URL(url, window.location.origin);
        normalizedUrl.searchParams.delete('section_id');
        return `${normalizedUrl.pathname}${normalizedUrl.search}`;
      }

      updatePagination(incoming) {
        const incomingPagination = incoming.querySelector('[data-collection-pagination]');
        if (this.pagination && incomingPagination) {
          this.pagination.innerHTML = incomingPagination.innerHTML;
        } else if (this.pagination && !incomingPagination) {
          this.pagination.remove();
          this.pagination = null;
        }
      }

      handleLoadError() {
        this.retryAttempts += 1;
        this.announce(this.dataset.errorMessage);

        if (this.retryAttempts <= 2 && this.sentinel) {
          this.retryTimer = window.setTimeout(() => {
            if (this.isConnected && this.hasMore && !this.isLoading) this.observer?.observe(this.sentinel);
          }, 1500 * this.retryAttempts);
          return;
        }

        this.observer?.disconnect();
        this.classList.remove('is-enhanced');
        this.classList.add('has-load-error');
      }

      announce(message) {
        if (!this.status || !message) return;
        this.status.textContent = '';
        requestAnimationFrame(() => {
          this.status.textContent = message;
        });
      }

      finish() {
        this.hasMore = false;
        this.nextPageUrl = '';
        this.dataset.nextPageUrl = '';
        this.observer?.disconnect();
        this.sentinel?.remove();
        this.sentinel = null;
      }
    }

    customElements.define('collection-infinite-scroll', CollectionInfiniteScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-popup"]) return;
  try {
    
  if (!customElements.get('lampeek-email-popup')) {
    class LampeekEmailPopup extends HTMLElement {
      constructor() {
        super();
        this.dismissedKey = 'lampeek_email_popup_dismissed';
        this.subscribedKey = 'lampeek_email_popup_subscribed';
        this.hasOpened = false;
        this.isOpen = false;
        this.previousFocus = null;
        this.timer = null;
        this.closeTimer = null;
        this.savedBodyStyles = null;
        this.handleScroll = this.handleScroll.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleSectionSelect = this.handleSectionSelect.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
      }

      connectedCallback() {
        this.overlay = this.querySelector('[data-email-popup-overlay]');
        this.dialog = this.querySelector('[data-email-popup-dialog]');
        if (!this.overlay || !this.dialog) return;

        this.addEventListener('click', this.handleClick);
        window.addEventListener('resize', this.handleResize);
        document.addEventListener('shopify:section:select', this.handleSectionSelect);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);

        const formSucceeded = this.dialog.dataset.formSuccess === 'true';
        const formHasErrors = this.dialog.dataset.formErrors === 'true';

        if (formSucceeded) {
          this.writeTimestamp(this.subscribedKey);
          this.open(true);
          return;
        }

        if (window.Shopify?.designMode) this.classList.add('is-design-mode');

        if (formHasErrors || window.Shopify?.designMode) {
          this.open(true);
          return;
        }

        if (this.isSuppressed()) return;
        this.setupTriggers();
      }

      disconnectedCallback() {
        this.cleanupTriggers();
        this.removeEventListener('click', this.handleClick);
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener('shopify:section:select', this.handleSectionSelect);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        document.removeEventListener('keydown', this.handleKeydown);
        window.clearTimeout(this.closeTimer);
        if (this.isOpen) this.unlockScroll();
      }

      setupTriggers() {
        const mode = this.dataset.triggerMode;
        const delay = Math.max(0, Number(this.dataset.delaySeconds) || 0) * 1000;

        if (mode === 'delay' || mode === 'either') {
          this.timer = window.setTimeout(() => this.open(), delay);
        }

        if (mode === 'scroll' || mode === 'either') {
          window.addEventListener('scroll', this.handleScroll, { passive: true });
          this.handleScroll();
        }
      }

      cleanupTriggers() {
        window.clearTimeout(this.timer);
        this.timer = null;
        window.removeEventListener('scroll', this.handleScroll);
      }

      handleScroll() {
        const threshold = Math.max(0, Number(this.dataset.scrollPercent) || 0);
        const available = document.documentElement.scrollHeight - window.innerHeight;
        const progress = available > 0 ? (window.scrollY / available) * 100 : 100;
        if (progress >= threshold) this.open();
      }

      handleClick(event) {
        const copyButton = event.target.closest('[data-email-popup-copy]');
        if (copyButton) {
          this.copyCode(copyButton);
          return;
        }

        if (event.target.closest('[data-email-popup-close], [data-email-popup-decline]')) {
          this.dismiss();
          return;
        }

        if (event.target === this.overlay && this.dataset.closeOnBackdrop === 'true') {
          this.dismiss();
        }
      }

      handleKeydown(event) {
        if (!this.isOpen) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          this.dismiss();
          return;
        }

        if (event.key !== 'Tab') return;
        const focusable = this.focusableElements();
        if (!focusable.length) {
          event.preventDefault();
          this.dialog.focus();
          return;
        }

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      handleResize() {
        if (this.isOpen && !this.viewportAllowed() && !window.Shopify?.designMode) {
          this.close(false);
        }
      }

      handleSectionSelect(event) {
        if (event.detail?.sectionId === this.dataset.sectionId) this.open(true);
      }

      handleBlockSelect(event) {
        const belongsToPopup = event.target instanceof Element && event.target.closest('lampeek-email-popup') === this;
        if (event.detail?.sectionId === this.dataset.sectionId || belongsToPopup) {
          this.open(true);
        }
      }

      viewportAllowed() {
        const mobile = window.matchMedia('(max-width: 46.8125rem)').matches;
        return mobile ? this.dataset.showMobile === 'true' : this.dataset.showDesktop === 'true';
      }

      isSuppressed() {
        return this.timestampIsActive(this.subscribedKey, this.dataset.subscribedDays)
          || this.timestampIsActive(this.dismissedKey, this.dataset.dismissalDays);
      }

      timestampIsActive(key, daysValue) {
        const timestamp = this.readTimestamp(key);
        const days = Math.max(0, Number(daysValue) || 0);
        return timestamp > 0 && Date.now() - timestamp < days * 86400000;
      }

      readTimestamp(key) {
        try {
          const value = window.localStorage.getItem(key);
          const timestamp = Number(value);
          return Number.isFinite(timestamp) ? timestamp : 0;
        } catch (_error) {
          return 0;
        }
      }

      writeTimestamp(key) {
        try {
          window.localStorage.setItem(key, String(Date.now()));
        } catch (_error) {
          return;
        }
      }

      open(force = false) {
        if (this.isOpen) return;
        if (this.hasOpened && !force) return;
        if (!force && !this.viewportAllowed()) return;
        if (!force && this.isSuppressed()) return;

        window.clearTimeout(this.closeTimer);
        this.hasOpened = true;
        this.isOpen = true;
        this.cleanupTriggers();
        this.previousFocus = document.activeElement;
        this.overlay.hidden = false;
        this.overlay.inert = false;
        this.lockScroll();
        document.addEventListener('keydown', this.handleKeydown);

        window.requestAnimationFrame(() => {
          this.overlay.classList.add('is-active');
          const preferredFocus = this.querySelector('input:not([type="hidden"]), [data-email-popup-copy], [data-email-popup-close]');
          (preferredFocus || this.dialog).focus();
        });
      }

      dismiss() {
        this.writeTimestamp(this.dismissedKey);
        this.close(true);
      }

      close(restoreFocus = true) {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.overlay.classList.remove('is-active');
        document.removeEventListener('keydown', this.handleKeydown);

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const duration = reducedMotion ? 0 : Math.max(0, Number(this.dataset.animationDuration) || 0);
        window.clearTimeout(this.closeTimer);
        this.closeTimer = window.setTimeout(() => {
          this.overlay.hidden = true;
          this.overlay.inert = true;
          this.unlockScroll();
          if (restoreFocus && this.previousFocus instanceof HTMLElement && document.contains(this.previousFocus)) {
            this.previousFocus.focus();
          }
        }, duration);
      }

      focusableElements() {
        return Array.from(this.dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
          .filter((element) => !element.hidden && element.getClientRects().length > 0);
      }

      lockScroll() {
        if (this.savedBodyStyles) return;
        const body = document.body;
        const scrollY = window.scrollY;
        this.savedBodyStyles = {
          position: body.style.position,
          top: body.style.top,
          width: body.style.width,
          overflow: body.style.overflow,
          scrollY
        };
        body.style.position = 'fixed';
        body.style.top = `-${scrollY}px`;
        body.style.width = '100%';
        body.style.overflow = 'hidden';
      }

      unlockScroll() {
        if (!this.savedBodyStyles) return;
        const body = document.body;
        const saved = this.savedBodyStyles;
        body.style.position = saved.position;
        body.style.top = saved.top;
        body.style.width = saved.width;
        body.style.overflow = saved.overflow;
        window.scrollTo(0, saved.scrollY);
        this.savedBodyStyles = null;
      }

      async copyCode(button) {
        const code = this.querySelector('[data-email-popup-code]')?.textContent.trim();
        if (!code) return;

        let copied = false;
        try {
          if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(code);
            copied = true;
          }
        } catch (_error) {
          copied = false;
        }

        if (!copied) copied = this.fallbackCopy(code);
        if (!copied) return;

        button.textContent = button.dataset.copiedLabel;
        window.setTimeout(() => {
          button.textContent = button.dataset.copyLabel;
        }, 1800);
      }

      fallbackCopy(code) {
        const input = document.createElement('textarea');
        input.value = code;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        let copied = false;
        try {
          copied = document.execCommand('copy');
        } catch (_error) {
          copied = false;
        }
        input.remove();
        return copied;
      }
    }

    customElements.define('lampeek-email-popup', LampeekEmailPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-product-rail')) {
    class FeaturedProductRail extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-product-viewport]');
        this.cards = [...this.querySelectorAll('[data-product-card]')];
        this.dots = [...this.querySelectorAll('.featured-products__dots span')];

        this.querySelector('[data-product-previous]')?.addEventListener('click', () => this.move(-1));
        this.querySelector('[data-product-next]')?.addEventListener('click', () => this.move(1));
        this.viewport?.addEventListener('scroll', () => this.update(), { passive: true });
      }

      move(direction) {
        const card = this.cards[0];
        if (!card) return;

        const gap = parseFloat(getComputedStyle(this.querySelector('.featured-products__track')).gap) || 0;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.viewport.scrollBy({
          left: direction * (card.getBoundingClientRect().width + gap),
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      }

      update() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          const card = this.cards[0];
          if (card) {
            const gap = parseFloat(getComputedStyle(this.querySelector('.featured-products__track')).gap) || 0;
            const index = Math.round(this.viewport.scrollLeft / (card.getBoundingClientRect().width + gap));
            this.dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
          }
          this.frame = null;
        });
      }
    }

    customElements.define('featured-product-rail', FeaturedProductRail);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('header-navigation')) {
    class HeaderNavigation extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        this.drawer = this.querySelector('[data-mobile-drawer]');
        this.drawerOpenButton = this.querySelector('[data-drawer-open]');
        this.drawerCloseButton = this.querySelector('[data-drawer-close]');
        this.drawerBackdrop = this.querySelector('[data-drawer-backdrop]');
        this.desktopToggle = this.querySelector('[data-desktop-menu-toggle]');
        this.desktopMenu = this.querySelector('[data-desktop-menu]');
        this.searchToggles = [...this.querySelectorAll('[data-search-toggle]')];
        this.activeSearchToggle = null;
        this.desktopSearch = this.querySelector('[data-desktop-search]');
        this.desktopSearchInput = this.querySelector('[data-desktop-search-input]');
        this.searchCloseButton = this.querySelector('[data-search-close]');
        this.panelRequest = 0;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.drawerOpenButton?.addEventListener('click', () => this.openDrawer(), options);
        this.drawerCloseButton?.addEventListener('click', () => this.closeDrawer(), options);
        this.drawerBackdrop?.addEventListener('click', () => this.closeDrawer(), options);
        this.desktopToggle?.addEventListener('click', () => this.toggleDesktopMenu(), options);
        this.searchToggles.forEach((toggle) => {
          toggle.addEventListener('click', () => this.toggleDesktopSearch(toggle), options);
        });
        this.searchCloseButton?.addEventListener('click', () => {
          this.panelRequest += 1;
          this.closeDesktopSearch();
        }, options);

        document.addEventListener('click', (event) => this.handleOutsideClick(event), options);
        document.addEventListener('keydown', (event) => this.handleKeydown(event), options);

        this.desktopMedia = window.matchMedia('(min-width: 46.875rem)');
        this.desktopMedia.addEventListener('change', () => {
          this.panelRequest += 1;
          this.closeDrawer(false);
          this.closeDesktopMenu();
          this.closeDesktopSearch(false);
        }, options);
      }

      disconnectedCallback() {
        this.controller?.abort();
        document.documentElement.classList.remove('mobile-navigation-open');
      }

      openDrawer() {
        if (!this.drawer) return;
        this.previouslyFocused = document.activeElement;
        this.drawer.removeAttribute('inert');
        this.drawer.setAttribute('aria-hidden', 'false');
        this.drawerOpenButton?.setAttribute('aria-expanded', 'true');
        this.drawerBackdrop?.setAttribute('tabindex', '0');
        this.classList.add('drawer-open');
        document.documentElement.classList.add('mobile-navigation-open');
        this.drawerCloseButton?.focus();
      }

      closeDrawer(restoreFocus = true) {
        if (!this.drawer) return;
        this.classList.remove('drawer-open');
        this.drawer.setAttribute('aria-hidden', 'true');
        this.drawer.setAttribute('inert', '');
        this.drawerOpenButton?.setAttribute('aria-expanded', 'false');
        this.drawerBackdrop?.setAttribute('tabindex', '-1');
        document.documentElement.classList.remove('mobile-navigation-open');
        this.drawer.querySelector('country-selector')?.close();
        if (restoreFocus) this.previouslyFocused?.focus();
      }

      panelDuration() {
        const value = getComputedStyle(this).getPropertyValue('--motion-panel').trim();
        if (value.endsWith('ms')) return Number.parseFloat(value);
        if (value.endsWith('s')) return Number.parseFloat(value) * 1000;
        return 210;
      }

      showDesktopPanel(panel) {
        if (!panel) return;
        panel._lampeekPanelCancel?.();
        panel.hidden = false;
        panel.dataset.panelState = 'opening';

        if (this.reducedMotion.matches) {
          panel.dataset.panelState = 'open';
          return;
        }

        window.requestAnimationFrame(() => {
          if (!panel.hidden) panel.dataset.panelState = 'open';
        });
      }

      hideDesktopPanel(panel) {
        if (!panel || panel.hidden) return Promise.resolve();
        if (panel._lampeekPanelPromise) return panel._lampeekPanelPromise;

        panel.dataset.panelState = 'closing';
        if (this.reducedMotion.matches) {
          panel.hidden = true;
          delete panel.dataset.panelState;
          return Promise.resolve();
        }

        panel._lampeekPanelPromise = new Promise((resolve) => {
          let timer;
          const cleanup = () => {
            panel.removeEventListener('transitionend', handleTransitionEnd);
            window.clearTimeout(timer);
            delete panel._lampeekPanelCancel;
            delete panel._lampeekPanelPromise;
          };
          const finish = (hidePanel) => {
            cleanup();
            if (hidePanel) {
              panel.hidden = true;
              delete panel.dataset.panelState;
            }
            resolve();
          };
          const handleTransitionEnd = (event) => {
            if (event.target === panel && event.propertyName === 'opacity') finish(true);
          };

          panel._lampeekPanelCancel = () => finish(false);
          panel.addEventListener('transitionend', handleTransitionEnd);
          timer = window.setTimeout(() => finish(true), this.panelDuration() + 50);
        });

        return panel._lampeekPanelPromise;
      }

      toggleDesktopMenu() {
        const shouldOpen = this.desktopToggle?.getAttribute('aria-expanded') !== 'true';
        if (shouldOpen) this.openDesktopMenu();
        else {
          this.panelRequest += 1;
          this.closeDesktopMenu();
        }
      }

      async openDesktopMenu() {
        if (!this.desktopMenu || !this.desktopToggle) return;
        const request = ++this.panelRequest;
        await this.closeDesktopSearch(false);
        if (request !== this.panelRequest) return;
        this.showDesktopPanel(this.desktopMenu);
        this.desktopToggle.setAttribute('aria-expanded', 'true');
      }

      closeDesktopMenu() {
        if (!this.desktopMenu || !this.desktopToggle) return Promise.resolve();
        this.desktopToggle.setAttribute('aria-expanded', 'false');
        return this.hideDesktopPanel(this.desktopMenu);
      }

      toggleDesktopSearch(toggle) {
        const shouldOpen = !this.isSearchOpen();
        if (shouldOpen) this.openDesktopSearch(toggle);
        else {
          this.panelRequest += 1;
          this.closeDesktopSearch();
        }
      }

      isSearchOpen() {
        return this.searchToggles.some((toggle) => toggle.getAttribute('aria-expanded') === 'true');
      }

      async openDesktopSearch(toggle) {
        if (!this.desktopSearch || !this.searchToggles.length) return;
        const request = ++this.panelRequest;
        await this.closeDesktopMenu();
        if (request !== this.panelRequest) return;
        this.activeSearchToggle = toggle;
        this.showDesktopPanel(this.desktopSearch);
        this.searchToggles.forEach((searchToggle) => searchToggle.setAttribute('aria-expanded', 'true'));
        window.requestAnimationFrame(() => {
          if (this.isSearchOpen()) this.desktopSearchInput?.focus();
        });
      }

      async closeDesktopSearch(restoreFocus = true) {
        if (!this.desktopSearch || !this.searchToggles.length) return;
        this.searchToggles.forEach((searchToggle) => searchToggle.setAttribute('aria-expanded', 'false'));
        await this.hideDesktopPanel(this.desktopSearch);
        if (restoreFocus) this.activeSearchToggle?.focus();
        this.activeSearchToggle = null;
      }

      handleOutsideClick(event) {
        if (this.desktopToggle?.getAttribute('aria-expanded') !== 'true') return;
        if (this.desktopToggle.contains(event.target) || this.desktopMenu?.contains(event.target)) return;
        this.panelRequest += 1;
        this.closeDesktopMenu();
      }

      handleKeydown(event) {
        if (event.key === 'Escape' && this.querySelector('country-selector details[open]')) return;
        if (event.defaultPrevented) return;

        if (event.key === 'Escape') {
          if (this.classList.contains('drawer-open')) {
            event.preventDefault();
            this.closeDrawer();
          } else if (this.isSearchOpen()) {
            event.preventDefault();
            this.panelRequest += 1;
            this.closeDesktopSearch();
          } else if (this.desktopToggle?.getAttribute('aria-expanded') === 'true') {
            event.preventDefault();
            this.panelRequest += 1;
            this.closeDesktopMenu();
            this.desktopToggle.focus();
          }
          return;
        }

        if (event.key !== 'Tab' || !this.classList.contains('drawer-open')) return;
        const focusable = [...this.drawer.querySelectorAll('a[href], button:not([disabled]), input, summary')]
          .filter((element) => element.getClientRects().length > 0);
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }

    customElements.define('header-navigation', HeaderNavigation);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-looks-by-you"] && !Shopify.designMode) return;
  try {
    
  class ProductLooksCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.track = this.querySelector('[data-looks-track]');
      this.viewport = this.querySelector('.product-looks__viewport');
      this.slides = Array.from(this.querySelectorAll('[data-looks-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-looks-dot]'));
      this.previousButton = this.querySelector('[data-looks-previous]');
      this.nextButton = this.querySelector('[data-looks-next]');
      this.controls = this.querySelector('[data-looks-controls]');
      this.index = 0;
      this.currentOffset = 0;
      this.pointerId = null;
      this.dragStartX = 0;
      this.dragStartOffset = 0;
      this.didDrag = false;
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };

      this.previousButton?.addEventListener('click', () => this.goTo(this.index - 1), options);
      this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1), options);
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.looksDot)), options));
      window.addEventListener('resize', () => this.updatePosition(), options);
      this.addEventListener('pointerdown', (event) => this.startDrag(event), options);
      this.addEventListener('pointermove', (event) => this.moveDrag(event), options);
      this.addEventListener('pointerup', (event) => this.endDrag(event), options);
      this.addEventListener('pointercancel', (event) => this.cancelDrag(event), options);
      this.addEventListener('click', (event) => {
        if (!this.didDrag) return;
        event.preventDefault();
        event.stopPropagation();
        this.didDrag = false;
      }, { ...options, capture: true });

      this.updatePosition();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.initialized = false;
    }

    goTo(index) {
      if (!this.slides.length) return;
      this.index = Math.max(0, Math.min(index, this.maxIndex()));
      this.updatePosition();
    }

    isMobile() {
      return window.matchMedia('(max-width: 46.8125rem)').matches;
    }

    visibleImages() {
      return this.isMobile() ? 1 : Number(this.dataset.desktopVisible || 3);
    }

    maxIndex() {
      return Math.max(0, this.slides.length - this.visibleImages());
    }

    maximumOffset() {
      return Math.max(0, this.track.scrollWidth - this.viewport.clientWidth);
    }

    offsetForIndex(index) {
      const slide = this.slides[index];
      if (!slide) return 0;
      return Math.min(slide.offsetLeft, this.maximumOffset());
    }

    startDrag(event) {
      if (event.button !== 0 || event.target.closest('a, button')) return;
      if (this.maxIndex() === 0) return;
      this.pointerId = event.pointerId;
      this.dragStartX = event.clientX;
      this.dragStartOffset = this.currentOffset;
      this.didDrag = false;
      this.track.classList.add('is-dragging');
      this.classList.add('is-dragging');
      this.setPointerCapture(event.pointerId);
    }

    moveDrag(event) {
      if (event.pointerId !== this.pointerId) return;
      const distance = event.clientX - this.dragStartX;
      if (Math.abs(distance) > 5) this.didDrag = true;
      const offset = Math.max(0, Math.min(this.dragStartOffset - distance, this.maximumOffset()));
      this.track.style.transform = `translateX(${-offset}px)`;
      if (this.didDrag) event.preventDefault();
    }

    endDrag(event) {
      if (event.pointerId !== this.pointerId) return;
      const distance = event.clientX - this.dragStartX;
      const threshold = Math.max(40, Math.min(96, this.viewport.clientWidth * 0.12));
      this.pointerId = null;
      this.track.classList.remove('is-dragging');
      this.classList.remove('is-dragging');
      if (this.hasPointerCapture(event.pointerId)) this.releasePointerCapture(event.pointerId);

      if (Math.abs(distance) >= threshold) {
        this.goTo(this.index + (distance < 0 ? 1 : -1));
      } else {
        this.updatePosition();
      }
    }

    cancelDrag(event) {
      if (event.pointerId !== this.pointerId) return;
      this.pointerId = null;
      this.track.classList.remove('is-dragging');
      this.classList.remove('is-dragging');
      if (this.hasPointerCapture(event.pointerId)) this.releasePointerCapture(event.pointerId);
      this.updatePosition();
    }

    updatePosition() {
      if (!this.track || !this.viewport) return;
      const maxIndex = this.maxIndex();
      this.index = Math.min(this.index, maxIndex);
      this.currentOffset = this.offsetForIndex(this.index);
      this.track.style.transform = `translateX(${-this.currentOffset}px)`;
      if (this.controls) this.controls.hidden = maxIndex === 0;
      if (this.previousButton) this.previousButton.disabled = this.index === 0;
      if (this.nextButton) this.nextButton.disabled = this.index === maxIndex;
      this.dots.forEach((dot, dotIndex) => {
        const isAvailable = dotIndex <= maxIndex;
        const isActive = dotIndex === this.index;
        dot.hidden = !isAvailable;
        dot.disabled = !isAvailable;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', String(isActive));
      });
    }
  }

  if (!customElements.get('product-looks-carousel')) {
    customElements.define('product-looks-carousel', ProductLooksCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.initialized || !this.dataset.url) return;
        this.initialized = true;

        this.observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          this.observer.disconnect();
          this.load();
        }, { rootMargin: '0px 0px 300px 0px' });
        this.observer.observe(this);
      }

      async load() {
        try {
          const response = await fetch(this.dataset.url);
          if (!response.ok) return;
          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const content = documentFragment.querySelector('[data-recommendations-content]');
          if (content?.innerHTML.trim()) {
            this.querySelector('[data-recommendations-content]').innerHTML = content.innerHTML;
          }
        } catch (error) {
          console.warn('Product recommendations could not be loaded.', error);
        }
      }
    }

    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lampeek-product-reviews')) {
    class LampeekProductReviews extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.items = [...this.querySelectorAll('[data-review-list-item]')];
        this.visibleCount = Number(this.dataset.initialCount) || 3;
        this.pageSize = Number(this.dataset.pageSize) || 3;
        this.loadMoreButton = this.querySelector('[data-review-load-more]');
        this.sortDetails = this.querySelector('[data-review-sort-details]');
        this.sortLabel = this.querySelector('[data-review-sort-label]');
        this.sortOptions = [...this.querySelectorAll('[data-review-sort-option]')];
        this.sortMode = 'recent';
        this.controller = new AbortController();
        const listenerOptions = { signal: this.controller.signal };

        this.loadMoreButton?.addEventListener('click', () => {
          this.visibleCount += this.pageSize;
          this.updateList();
        }, listenerOptions);
        this.sortOptions.forEach((option) => {
          option.addEventListener('click', () => this.selectSort(option), listenerOptions);
        });
        document.addEventListener('click', (event) => {
          if (this.sortDetails?.open && !this.contains(event.target)) this.closeSort();
        }, listenerOptions);
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !this.sortDetails?.open) return;
          event.preventDefault();
          this.closeSort(true);
        }, listenerOptions);

        if (this.sortOptions.length) {
          this.sortReviews();
        } else {
          this.updateList();
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      updateList() {
        this.items.forEach((item, index) => {
          item.hidden = index >= this.visibleCount;
        });
        if (this.loadMoreButton) {
          this.loadMoreButton.hidden = this.visibleCount >= this.items.length;
        }
      }

      selectSort(option) {
        this.sortMode = option.dataset.reviewSortOption || 'recent';
        if (this.sortLabel) this.sortLabel.textContent = option.textContent;
        this.sortOptions.forEach((sortOption) => {
          sortOption.setAttribute('aria-current', String(sortOption === option));
        });
        this.closeSort();
        this.sortReviews();
      }

      closeSort(restoreFocus = false) {
        if (!this.sortDetails?.open) return;
        this.sortDetails.removeAttribute('open');
        if (restoreFocus) this.sortDetails.querySelector('summary')?.focus();
      }

      sortReviews() {
        const mode = this.sortMode;
        this.items.sort((first, second) => {
          const firstCard = first.querySelector('[data-review-card]');
          const secondCard = second.querySelector('[data-review-card]');
          if (mode === 'highest') {
            return Number(secondCard?.dataset.reviewRating) - Number(firstCard?.dataset.reviewRating);
          }
          if (mode === 'lowest') {
            return Number(firstCard?.dataset.reviewRating) - Number(secondCard?.dataset.reviewRating);
          }
          const firstDate = Date.parse(firstCard?.dataset.reviewDate || '') || 0;
          const secondDate = Date.parse(secondCard?.dataset.reviewDate || '') || 0;
          if (firstDate !== secondDate) return secondDate - firstDate;
          return Number(first.dataset.reviewOriginalIndex) - Number(second.dataset.reviewOriginalIndex);
        });
        const list = this.querySelector('[data-review-list]');
        this.items.forEach((item) => list?.append(item));
        this.visibleCount = Number(this.dataset.initialCount) || 3;
        this.updateList();
      }
    }

    customElements.define('lampeek-product-reviews', LampeekProductReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('lampeek-product')) {
    class LampeekProduct extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.variants = JSON.parse(this.querySelector('[data-product-variants]').textContent);
        this.media = JSON.parse(this.querySelector('[data-product-media]').textContent);
        this.colorPosition = Number(this.dataset.colorOptionPosition) || 0;
        this.variantInput = this.querySelector('[data-variant-id]');
        this.selectedOptions = this.currentVariant()?.options.slice() || [];
        this.galleryTrack = this.querySelector('[data-pdp-gallery-track]');

        this.addEventListener('click', (event) => this.handleClick(event));
        this.addEventListener('change', (event) => this.handleChange(event));
        this.galleryTrack?.addEventListener('scroll', () => this.updateGalleryDots(), { passive: true });
      }

      currentVariant() {
        return this.variants.find((variant) => String(variant.id) === String(this.variantInput?.value));
      }

      handleClick(event) {
        const ratingLink = event.target.closest('.pdp__rating[href="#ProductReviews"]');
        if (ratingLink) {
          const reviewsSection = document.getElementById('ProductReviews');
          if (reviewsSection) {
            event.preventDefault();
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            reviewsSection.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
          }
          return;
        }

        const option = event.target.closest('[data-product-option]');
        if (option) {
          this.selectOption(Number(option.dataset.optionPosition), option.dataset.optionValue);
          return;
        }

        if (event.target.closest('[data-gallery-previous]')) this.moveGallery(-1);
        if (event.target.closest('[data-gallery-next]')) this.moveGallery(1);
      }

      handleChange(event) {
        const select = event.target.closest('[data-product-option-select]');
        if (select) this.selectOption(Number(select.dataset.optionPosition), select.value);
      }

      selectOption(position, value) {
        this.selectedOptions[position - 1] = value;
        const variant = this.variants.find((candidate) =>
          candidate.options.every((option, index) => option === this.selectedOptions[index])
        );
        if (!variant) return;

        this.updateVariant(variant);
      }

      updateVariant(variant) {
        this.variantInput.value = variant.id;
        this.selectedOptions = variant.options.slice();

        const currentPrice = this.querySelector('[data-current-price]');
        const comparePrice = this.querySelector('[data-compare-price]');
        const onSale = variant.compareAt && variant.compareAt > variant.price;
        currentPrice.textContent = variant.priceFormatted;
        currentPrice.classList.toggle('is-sale', Boolean(onSale));
        comparePrice.textContent = variant.compareAtFormatted || '';
        comparePrice.hidden = !onSale;
        const stock = this.querySelector('[data-product-stock]');
        stock.classList.toggle('is-unavailable', !variant.available);
        stock.querySelector('[data-stock-text]').textContent = variant.available ? this.dataset.inStockLabel : this.dataset.soldOutLabel;

        const addButton = this.querySelector('[data-add-to-cart]');
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel;

        this.querySelectorAll('[data-product-option]').forEach((button) => {
          const selected = variant.options[Number(button.dataset.optionPosition) - 1] === button.dataset.optionValue;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
        });

        this.querySelectorAll('[data-product-option-select]').forEach((select) => {
          select.value = variant.options[Number(select.dataset.optionPosition) - 1];
        });

        let selectedColorKey = '';
        if (this.colorPosition) {
          const selectedColor = variant.options[this.colorPosition - 1];
          selectedColorKey = this.handleize(selectedColor);
          const selectedColorLabel = this.querySelector('[data-selected-color]');
          if (selectedColorLabel) selectedColorLabel.textContent = selectedColor;
        }
        this.renderGallery(variant, selectedColorKey);

        const url = new URL(this.dataset.productUrl, window.location.origin);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', `${url.pathname}${url.search}`);
      }

      renderGallery(variant, colorKey) {
        const visibleMedia = this.media.filter((item) => {
          if (item.variantIds.length) {
            return item.variantIds.some((variantId) => String(variantId) === String(variant.id));
          }
          return item.owner === 'shared' || item.owner === colorKey;
        });
        if (!visibleMedia.length) return;

        const fragment = document.createDocumentFragment();
        visibleMedia.forEach((item, index) => {
          const figure = document.createElement('figure');
          figure.className = 'pdp__gallery-item';
          figure.dataset.galleryItem = '';
          const image = document.createElement('img');
          image.alt = item.alt;
          image.width = item.width;
          image.height = item.height;
          image.sizes = this.dataset.imageSizes;
          image.loading = index === 0 ? 'eager' : 'lazy';
          image.fetchPriority = index === 0 ? 'high' : 'auto';
          image.srcset = item.srcset;
          image.src = item.src;
          figure.append(image);
          fragment.append(figure);
        });

        this.galleryTrack.replaceChildren(fragment);
        this.galleryTrack.scrollTo({ left: 0, behavior: 'auto' });
        this.renderGalleryControls(visibleMedia.length);
      }

      renderGalleryControls(count) {
        const controls = this.querySelector('[data-pdp-gallery-controls]');
        const dots = this.querySelector('[data-pdp-gallery-dots]');
        controls.hidden = count < 2;
        dots.replaceChildren(...Array.from({ length: count }, (_, index) => {
          const dot = document.createElement('span');
          if (index === 0) dot.className = 'is-active';
          return dot;
        }));
      }

      moveGallery(direction) {
        const item = this.galleryTrack?.querySelector('[data-gallery-item]');
        if (!item) return;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.galleryTrack.scrollBy({
          left: direction * item.getBoundingClientRect().width,
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      }

      updateGalleryDots() {
        if (this.galleryFrame) return;
        this.galleryFrame = requestAnimationFrame(() => {
          const item = this.galleryTrack?.querySelector('[data-gallery-item]');
          if (item) {
            const index = Math.round(this.galleryTrack.scrollLeft / item.getBoundingClientRect().width);
            this.querySelectorAll('[data-pdp-gallery-dots] span').forEach((dot, dotIndex) => {
              dot.classList.toggle('is-active', dotIndex === index);
            });
          }
          this.galleryFrame = null;
        });
      }

      handleize(value) {
        return value
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-|-$/g, '');
      }
    }

    customElements.define('lampeek-product', LampeekProduct);
  }

  } catch(e) { console.error(e); }
})();
})();
